<template>
  <div class="tutorial-container-superadmin col-sm-4">
    <div class="tutorial-content">
      <div class="card tutorial-card">
        <div class="card-header text-end">
          <div class="card-arrow-superadmin"></div>
          <div class="d-flex justify-content-end">
            <button 
              class="btn btn-link text-white" 
              @click="$emit('close')"
            >
              <i class="fa fa-xmark"></i>
            </button>
          </div>
        </div>
        
        <div class="card-body">
          <h3 class="text-white">¿Cómo dar de alta a mis colaboradores?</h3>
          <span>
            Dirígete a 'Usuarios'. Haz scroll vertical hacia abajo y da clic en 'Descargar plantilla', 
            completa los datos de los usuarios que desees agregar dentro del documento. 
            Finalmente haz clic en 'Subir archivo csv' para completar la carga de tus colaboradores.
          </span>
        </div>
        
        <div class="card-footer d-flex justify-content-end pb-3 pe-5 pt-2">
          <a 
            href="#" 
            @click.prevent="$emit('open-video')" 
            class="text-end text-white"
          >
            Ver tutorial
            <i class="fa ms-2 fa-arrow-right text-white"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TutorialCard',
  
  emits: ['close', 'open-video']
}
</script>

<style scoped>
.tutorial-card {
  background-color: #4000BC;
  color: #fff;
  text-align: left;
}

.tutorial-card .card-body {
  text-align: left;
}

.tutorial-card .card-header {
  border-bottom: none;
  background-color: inherit !important;
}

.tutorial-card .card-footer {
  border-top: none;
  background-color: inherit !important;
}

.tutorial-container-superadmin {
  position: absolute;
  transform: translateX(-80%);
  z-index: 1000;
}

.tutorial-container-superadmin .tutorial-content {
  transform: translate(10px, 10px);
}

.card-arrow-superadmin {
  position: absolute;
  width: 40px;
  height: 40px;
  margin-top: -23px;
  background-color: #4000BC;
  transform: rotate(45deg);
  right: 20px;
  z-index: -100;
}

@media(max-width: 576px) {
  .tutorial-container-superadmin {
    z-index: 1000;
    left: 0;
    top: 0;
    width: 95%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    transform: none;
  }

  .tutorial-container-superadmin .tutorial-content {
    transform: translate(5px, 50px) !important;
  }
}
</style>